import { makeStyles } from "@mui/styles";

const aboutStyle = makeStyles((theme) => ({
  boldText: {
    fontWeight: "600 !important",
    fontSize: "2rem !important",
  },
  hrLine: {
    height: "3px",
    width: "60px",
    backgroundColor: "#008374",
    margin: "0px auto",
  },
  image:{
    width:"100%",
    height:"auto",
    borderRadius:"30px",
    marginBottom:"20px"
  },
}));

export default aboutStyle;
